import { FoodListDivider } from "components/foodItem/FoodListItem/styled"
import FoodListItem from "components/foodItem/FoodListItem"
import PATHS from "router/paths"
import { useMyFoods } from "features/food/hooks/index"
import { useMealTypeQueryParams } from "features/meal/hooks"
import { useGoToMyFoodDetails } from "features/food/hooks/myFood/useMyFoodDetails"
import { useSetPageTitle } from "libs/ga"
import { useLogBrazeEvent } from "libs/braze"
import useLogMealFromFood from "features/meal/hooks/logMeal/useLogMealFromFood"
import {
  CreateMyFoodLink,
  CreateMyFoodLinkWrapper,
  FoodList,
  MyListWrapper,
} from "./styled"

const MyList = () => {
  useSetPageTitle("My Recipe")
  const { myFoods } = useMyFoods()
  const mealTypeQueryParams = useMealTypeQueryParams()
  const onGoToFoodDetails = useGoToMyFoodDetails()
  const { handleLogMealFromFood } = useLogMealFromFood()
  const { logBrazeManualInputStarted } = useLogBrazeEvent()

  return (
    <MyListWrapper>
      <CreateMyFoodLinkWrapper>
        <CreateMyFoodLink
          to={`${PATHS.app.food.create}${mealTypeQueryParams}`}
          onClick={() => {
            logBrazeManualInputStarted()
          }}
        >
          Add new recipe
        </CreateMyFoodLink>
      </CreateMyFoodLinkWrapper>

      <FoodList>
        {myFoods.map((food, index) => (
          <div key={food.id}>
            <FoodListItem
              food={food}
              onAdd={() => {
                handleLogMealFromFood(food)
              }}
              onSelect={() => {
                onGoToFoodDetails(food)
              }}
            />
            {index < myFoods.length - 1 && <FoodListDivider />}
          </div>
        ))}
      </FoodList>
    </MyListWrapper>
  )
}

export default MyList
